class PaginationLabel extends HTMLElement {

  constructor() {
    super();

    this.state = {
      root: window.theme.category ? window.theme.category.stateLayer.state : window.theme.searchResults.stateLayer.state
    }
  }


  connectedCallback() {
    this.subscribeToEvents();
  }

  subscribeToEvents() {
    if(window.theme.searchResults) {
      window.theme.searchResults.eventBus.subscribe('searchResults:state:products:updated', (products) => {

        if(products.length > 0) {
          this.render()
        } else {
          this.classList.add('hidden');
        }
      })
    }

    if(window.theme.category) {
      window.theme.category.eventBus.subscribe('category:api:products:fetched', (res) => {
        if(res.products.hits.length > 0) {
          this.render()
        } else {
          this.classList.add('hidden');
        }
      })
    }
  }

  render() {
    const { pagination } = this.state.root;
    const start = pagination.from === 0 ? 1 : pagination.from;
    const end = Math.min(pagination.from + pagination.size, pagination.total);

    this.innerHTML = '';
    this.insertAdjacentHTML('beforeend', `Showing ${start} - ${end} of ${pagination.total}`);
  }
}

customElements.define('pagination-label', PaginationLabel);
